module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Two")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he anger on Pete’s face slipped for an instant. “Come again?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I said, make me. What are you going to do, pick me up and throw me out? You can’t walk, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s very cute,” he said. “Is that some sort of warped reverse psychology? Am I supposed to jump up and miraculously walk across the room now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She slammed her hands down on the armrests of his chair, caging him in, getting right in his face—and boy, did he smell good, just like she’d always imagined he would. A clean, masculine scent.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“Look, doc, for all I care, you can rot in that chair. I’m doing this for your parents, who I realize are not what you would call warm and fuzzy, but who seem to genuinely care about you. They think you’ll make a full recovery, which, let’s ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("face it, we both know isn’t gonna happen. You’ll have a limp, possibly to the point of needing a cane to negotiate certain situations, or it may barely be recognizable. And of course you can look forward to more surgeries and physical therapy in the future, since that knee is only good for about ten years—fifteen if you’re lucky.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How you do all depends on how hard you’re willing to work. Then again, maybe you won’t work at all. You’ll sit in that chair feeling sorry for yourself until every muscle has atrophied beyond repair and you never walk again. It’s your choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face remained stoic, but his Adam’s apple bobbed as he swallowed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She straightened to her full five feet four inches, but didn’t back away. She could tell that her presence made him uncomfortable. At well over six feet tall, he probably wasn’t used to people towering over him. In many respects, it had to make him feel overpowered, if only subconsciously. It was very likely part of the reason he insisted on pushing everyone away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That wouldn’t work with her. She excelled at making a pest of herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A nerve in his jaw jumped and for a second he looked a lot like his father. “Did anyone ever tell you that your methods suck?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t help but crack a smile. “Honey, I haven’t even started. When I’m finished with you, you’re going to either love me or hate me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think I hate you already,” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hate me all you want, doc. As long as you bust your butt to get better. You’ve got people rooting for you.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What people?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At the hospital. The people who used to be your friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You work there?” A speck of recognition lit his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In the PT department.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought I recognized you.” He took her in from head to toe. “But, didn’t you used to—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Be enormous?” she interjected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pete rolled his eyes. Why was it that all women had such a warped self image? She may have been a little on the thick side, he honestly couldn’t remember. What he did remember was her eyes. They were so bright and full of life. That he’d forgotten her was an indication of how empty his own life had become. “I was going to ask if you used to have long hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yep, down to my butt,” she said, fingering the short dark spirals at her nape. “We should get started. We have a lot of work ahead of us. Your parents gave me a tour of the exercise room and showed me the equipment they’ve rented. It should be adequate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Boy, she was stubborn. Hadn’t he already told her he didn’t want her help? Hadn’t he asked her to leave? “I don’t think you heard what I said.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stepped behind him and grabbed the handles of his chair, leaning close to his ear. “Oh, I heard you. I’m just ignoring you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her warm breath tickled his ear, making it difficult to concentrate—until she started pushing him toward the door. Beautiful or not, she was ticking him off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grabbed the wheels, grinding them to a jerky halt. “Look, Maggie….”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“No, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" look.” She circled the chair, propping herself on ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("his armrests again, getting in his face for the second time that day. If she were a man, he probably would have decked her by now. And if she were a man, he wouldn’t be having such a hard time "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" looking down her shirt, which was fairly low-cut and just happened to be at eye level. Her chest was full and lush and lightly freckled across her cleavage. It was just…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wow.")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He couldn’t stop himself from enjoying the view.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to get you out of that chair, whether you like it or not,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tried to keep his gaze locked on her face. “So I can limp around and make a fool of myself? I don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t mean to suggest that anyone with a limp is a fool? The thousands of men who come home from war with debilitating injuries are fools? Children born with crippling birth defects are fools?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s different,” he mumbled. He could see exactly what she was trying to do, but she didn’t understand—anything less than perfect wasn’t good enough. Not for him. Not for his parents.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And certainly not for Lizzy, his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex")]), _vm._v("-fiancée.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you plan to do with the rest of your life, doc? What about all those years you spent in college and medical school? Would you really throw all of that away because you’re afraid?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He narrowed his eyes. “Let’s get one thing straight. I’m not afraid. I just don’t do things halfway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Halfway?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked away. “You wouldn’t understand.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("She arched her neck, forcing him to look at her. She had ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("the darkest eyes he’d ever seen, and so deep he could get lost in them. “Try me.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I worked in the ER. The pace is fast and reaction time is critical. If I were to rejoin my staff in anything less than perfect physical condition, I would be compromising the integrity of the entire team. I can’t, with a clear conscience, limp around the ER just hoping that I won’t slow everyone else down.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes narrowed slightly. “And your colleagues, they’ve expressed their concern to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not exactly. They would never come right out and say that to me, but I know what they’re thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Really?” She looked intrigued. “Forget medicine altogether. You should look into a job at one of those psychic hot-line places.” She leaned closer, until it was almost impossible "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" to look at her breasts. They were just so right there in his face. “Tell me, doc, what am I thinking right now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He cleared his throat. “Given your track record today, I’d have to guess it’s either rude or sarcastic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling, she backed away and he heaved a silent sigh of relief. He may have been a cripple, but he was still a man—a man who hadn’t had the pleasure of a woman’s company in four months. Four very "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("long")]), _vm._v(" months.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually, I was thinking that you smell great. It’s that clean, crisp cologne that makes me think of camping in October. You know, just before the leaves start to fall. When it’s not quite cold enough for winter coats, but a jacket is too light, and the heat of the campfire keeps you toasty warm. The kind of night to cuddle up in a sleeping bag with someone special and…well, you get the picture. Do you remember nights like that, doc?”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unfortunately he did. Vividly. And he couldn’t help imagining himself snuggled up, sharing a sleeping bag with someone like her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tried to swallow, realizing suddenly that his mouth had gone bone-dry. She was messing with his head. And she was good at it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know what else I was thinking? If you really don’t care what people think of you, why would you bother putting on cologne in the first place? Hell, why bother shaving? I was also wondering, if you no longer care about your career, why you were reading a medical journal when I came in earlier? Then I was thinking, if you’re so content sitting in that chair, why does it bug the hell out of you every time I get close and you have to look up at me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because I’m not used to having breasts shoved in my face? He couldn’t very well say that now, could he? “You seem to have all the answers. Why don’t you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re afraid. You’re afraid to be anything less than perfect. I’ll let you in on a little secret, doc. You weren’t perfect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that so?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You only think you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pete glared up at her with piercing blue eyes—eyes filled with a world of hurt and horrors she could only imagine. Which was why she was even more determined to see this through. He seemed so close to cracking, but she wasn’t quite there yet. So many people would be disappointed if she failed. She’d been chosen for this job because she had a reputation for dealing well with difficult clients. The man just didn’t realize how much everyone at the hospital cared about him. She cared, too, probably too much for her own good—and his.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But whatever he could dish out, she could take. God knows she’d been through much worse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sat casually on the sofa, as if she didn’t have a care in the world. “So what do you say, doc?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pete wheeled himself to the window behind her so she could no longer see him, but she couldn’t miss the exasperation in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I never thought I was perfect,” he said. “And while your insight on my life is truly fascinating, you couldn’t be further off base.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay. Prove it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I do, will you go away?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hopeful ring to his voice made her laugh. “Yeah, prove to me without a doubt that I’m completely wrong about you, that you don’t need me, and I’ll go away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a pause, then he said, “Maggie, turn around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something about the way he said her name sent chills across her skin. She shifted around to see him and found herself looking directly at…his crotch? Her eyes traveled up all six-feet-however-many inches of him as he walked—okay, limped—around the couch, until he was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("standing")]), _vm._v(" in front of her. He was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("standing.")]), _vm._v(" Then he leaned down and wedged his hands on the back of the loveseat on either side of her head, caging her in. Instinctively she pressed herself deeper into the cushions and her heart started to pound like crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh. My. God.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned in close, until they were nose to nose, flashed her a cocky smile and said, “How do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If her jaw hadn’t been fixed to her skull it would have been lying in her lap. “You sneaky son of a bitch. You can walk!”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you convinced?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She scrambled from under his arm and jumped to her feet. “How long have you been walking?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He lowered himself onto the arm of the sofa, wincing slightly as he brought his foot to rest on the floor. “A while. I use the equipment at night, when I’m sure I’ll have some privacy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She circled him, examining his knee, wishing she could get a better look. Now didn’t seem the time to ask him to drop his pants. “What’s your range of motion?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s stiff, and total extension is still tough. Impossible really.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your muscles are short from all the weight lifting you used to do. You’re not working with enough resistance. We’ll fix that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes widened. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“We?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we.")]), _vm._v(" You’ve done a lot on your own, but with my help there’s no telling what you could accomplish. I thought you’d been sitting around letting your muscles deteriorate. This will cut months off your therapy. We should start today. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Right now.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t do that,” he said, his voice rich with resignation. “Not today. Not ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean you can’t? You’ve come so far. I want to help you. Everyone will be so thrilled—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!” He shot up so fast that he lost his balance and almost fell into her. She grabbed hold of his arm to steady him, but he pushed her hand away. “I don’t need your help, and I don’t want you telling anyone anything. I don’t want anyone seeing me this way.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("At that moment it became perfectly clear. He was embarrassed. He didn’t want anyone, not even his closest ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("friends and family, to see him struggling. Pride was getting in the way of his recovery, making him feel he had to do it alone, when now, more than ever, he needed help. He needed the support of the people who cared about him. Didn’t he understand that he could only take this so far on his own?")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Obviously, he didn’t. She could tell him that it didn’t matter that he wasn’t perfect, that he was still the same man inside. That when he stood, even on a bad leg, he was still a powerful presence. She could even tell him that when he’d pinned her to the couch like that it had made her heart go berserk, and that his classically handsome features still left her a little breathless. That seeing him in the hospital had always lifted her spirits, and often she would make excuses to visit the ER just to get a glimpse of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could tell him that she almost didn’t take him on as a patient, for fear that she was too emotionally attached. But she knew she would never have the guts to say it. Not only would it be completely unprofessional, she would never humiliate herself that way. He was a million miles out of her league.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d like you to leave now,” he said, hobbling back over to his chair and lowering himself into it. “I can do this on my own. And though I can’t force you, I’d appreciate it if you didn’t tell anyone what you saw today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You need me, doc. Deep down, you know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wheeled himself toward the door. “I’m sure you can find your way out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was losing ground fast. It was time to pull out the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" heavy artillery. “Is this what your fiancée would have wanted?”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned to her, his eyes blank. “Goodbye, Maggie. Thanks for stopping by.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just like that, she’d lost the battle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For now, anyway.")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8a6cda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426874178_ch02.vue
// module id = 78
// module chunks = 0